export const LOAD_ROLES = 'LOAD_ROLES'
export const ADD_ROLE = 'ADD_ROLE'
export const UPDATE_ROLE = 'UPDATE_ROLE'
export const DELETE_ROLE = 'DELETE_ROLE'
export const LOAD_ALL_ROLES = 'LOAD_ALL_ROLES'
